import React, { CSSProperties } from 'react';
import styled from 'styled-components/macro';
import BaseTextarea from '../../../ui/Textarea';
import { fieldBase } from '../../../ui/Form';
import { getFieldWrapStyle } from '../Field';
import { BLACK_60 } from '../constants/colors';

export const TEXTAREA_MIN_HEIGHT = 160;

export interface TextareaProps extends fieldBase<string> {
  style?: CSSProperties;
  maxLength?: number;
  onFocus?: (value: string) => void;
  onBlur?: (value: string) => void;
  onClick?: (e: React.MouseEvent<HTMLTextAreaElement, MouseEvent>) => void;
  dataTestId?: string;
}

const StyledTextarea = styled(BaseTextarea)<{ $minHeight: CSSProperties['minHeight'] }>`
  textarea {
    resize: vertical;
    min-height: ${({ $minHeight }) =>
      typeof $minHeight === 'number' ? `${$minHeight}px` : $minHeight};

    &::placeholder {
      color: ${BLACK_60};
    }
  }

  & > div {
    padding: 0;
  }
`;

const Textarea = ({ style, error, ...props }: TextareaProps) => {
  const { minHeight, height, ...restStyle } = style ?? {};
  const textareaMinHeight = minHeight ?? height ?? TEXTAREA_MIN_HEIGHT;

  return (
    <StyledTextarea
      {...props}
      error={error}
      style={getFieldWrapStyle(error, restStyle)}
      $minHeight={textareaMinHeight}
    />
  );
};

export default Textarea;
